const itens = [
  {
    valor: '+500',
    rotulo: 'empresas e órgãos atendidos',
    icon: 'ri-team-line',
  },
  {
    valor: 'Direto',
    rotulo: 'atendimento direto com o proprietário',
    icon: 'ri-user-star-line',
  },
  {
    valor: 'Completo',
    rotulo: 'projeto, fornecimento, entrega e montagem',
    icon: 'ri-tools-line',
  },
  {
    valor: 'Nordeste',
    rotulo: 'projetos avaliados conforme porte e logística',
    icon: 'ri-map-pin-2-line',
  },
];

export default function ProvaCapacidade() {
  return (
    <section className="bg-white border-y border-background-200/60">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
          {itens.map((item) => (
            <div key={item.rotulo} className="flex flex-col items-start">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-4">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-foreground-950 text-[26px] md:text-[30px] font-semibold tracking-tight leading-none mb-2">
                {item.valor}
              </span>
              <span className="text-foreground-500 text-[13px] md:text-[14px] leading-snug">
                {item.rotulo}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}